import { loadTFJSModelFromDB } from "../utils/utils";

export default class VehicleQuality{
    constructor () {
        return (async () => {
            this.config = await this.loadConfig();
            this.quality_model    = await this.loadModel();
            this.id_to_class= {
                0:"bad",
                1:"good"
            }
            this.hasError=false;
            this.errorMessage="";
            return this;
          })();
    }
    checkModelisLoaded(){
        if(this.quality_model != undefined){
            return true;
        }else{
            return false;
        }
    }
    async loadConfig(){
        return fetch("../config/config.json").then((res)=>{            
            return res.json();
        }).then((data)=>{
            return data;
        }).catch((err)=>{
            console.error(err)
        });
    }


    async loadModel(){
        try{
            if (this.checkModelisLoaded()){
                return this.model;
            }
            const [model_json,model_weight] = await loadTFJSModelFromDB(this.config["URLS"]["QUALITY_MODEL_JSON"],this.config["URLS"]["QUALITY_MODEL_WEIGHT"],"QUALITY_MODEL_JSON","QUALITY_MODEL_WEIGHT")
            
            let mw1 = new File([model_weight], "group1-shard1of1.bin");
            let uint8Array = new Uint8Array(model_json);

            const decoder = new TextDecoder('utf-8');
            const string1 = decoder.decode(uint8Array);

            let mj1 = new File([string1], "model.json", {
                type: "application/json",
            });

            let model = await window.tf.loadGraphModel(
                window.tf.io.browserFiles([mj1,mw1])
            )
            return model; 
        }catch(error){
            console.log(error)
            this.hasError = true;
        }
        
    }

    preProcess(image){
        const input = window.tf.tidy(() => {
            return window.tf.image
                .resizeBilinear(image, [this.config["INPUTS"]["QUALITY_INPUT_HEIGHT"], this.config["INPUTS"]["QUALITY_INPUT_WIDTH"]]) 
                .div(255.0)
                // mean
                .sub([0.485, 0.456, 0.406]) 
                // std
                .div([0.229, 0.224, 0.225])
                .expandDims(0); 
        });
        return input;
    }
    postProcess(output){
        const probabilities = window.tf.softmax(output,1);
        const argMax = probabilities.argMax(1);
        const label = argMax.dataSync()[0];
        const score = probabilities.gather(argMax, 1).dataSync()[0];
        return [this.id_to_class[label],score];
    }
    async predict(image,vehicleType){
        let img = window.tf.browser.fromPixels(image);
        this.hasError=false;
        this.errorMessage="";
        img = this.preProcess(img);
        let net_output = await this.quality_model.execute(img);
        let [output,score] = this.postProcess(net_output); 
        return [output,score,this.hasError,this.errorMessage];
    }

}